import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import logo from '../assets/images/inclass_logo.png';
import '../css/Login.css';
import { setToken } from '../utils/auth';
import API_BASE from '..//config';

function Login({ setIsAuthenticated, setUserRole, setCurrentUser }) {
  const [credentials, setCredentials] = useState({
    email: '',
    password: ''
  });

  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const expired = params.get('expired');
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { id, value } = e.target;
    setCredentials(prev => ({
      ...prev,
      [id]: value
    }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    
    
    try {
      // künstliche Verzögerung einbauen (z.B. 2 Sekunden)
      //await new Promise(resolve => setTimeout(resolve, 2000));
      const response = await fetch(`${API_BASE}/api/auth/login`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: credentials.email,
          password: credentials.password
        })
      });
      
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.message || 'Login fehlgeschlagen');
      }
      
      // Store authentication data
      setToken(data.token);
      localStorage.setItem('isAuthenticated', 'true');
      localStorage.setItem('userRole', data.user.role);
      localStorage.setItem('currentUser', JSON.stringify({
        name: data.user.name,
        email: data.user.email,
        id: data.user._id
      }));

      // Update state
      setIsAuthenticated(true);
      setUserRole(data.user.role);
      setCurrentUser({
        name: data.user.name,
        email: data.user.email,
        id: data.user._id
      });

      // Redirect based on role
      navigate(data.user.role === 'admin' ? '/dashboard' : '/');
      
    } catch (err) {
      setError(err.message || 'Anmeldefehler');
    }finally {
      setIsLoading(false); // Spinner deaktivieren
    }
  };

  return (
    <div className="login-container">
      <img src={logo} alt="Website Logo" className="login-logo" />

      {expired && (
        <div className="session-expired">
          ⚠️ Diese Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.
        </div>
      )}


      <div className="login-card">
        
        {error && <div className="error-message">{error}</div>}

        {isLoading ? (
          <div className="loading-container">
            <div className="spinner"></div>
            <p>Startseite wird geladen...</p>
          </div>
        ) : (
        
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="email">E-mail</label>
            <input 
              type="email" 
              id="email" 
              placeholder="@beispiel.de" 
              value={credentials.email}
              onChange={handleChange}
              required 
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Passwort</label>
            <input 
              type="password" 
              id="password" 
              placeholder="**********" 
              value={credentials.password}
              onChange={handleChange}
              required 
            />
          </div>
          
          <button type="submit" className="login-button">Einloggen</button>

          <div className="login-links">
            {/* <Link to="/forgot-password" className="forgot-password">Passwort vergessen?</Link> */}
            {/* <p className="register-link">Sie haben noch kein Konto? <Link to="/register">Hier registrieren</Link></p> */}
          </div>

        </form>
        
      )}
      </div>
    </div>
  );
}

export default Login;